/** Límite por consulta al cargar historial (entregado y cancelado en paralelo). */
export const ORDERS_HISTORY_FETCH_LIMIT = 500;
